import React from 'react';
import OverflowComparison from './OverflowComparison';
import { MainImagesProps } from './types';
import type { CompetitorType } from '../../types';
import {
	comparisonImages,
	type ComparisonImages,
} from '../../assets/imageImports';

const MainImages: React.FC<MainImagesProps> = ({
	className,
	competitor,
	competitorName,
	imageType,
}) => {
	const getAssets = () => {
		const images = comparisonImages[competitor as keyof ComparisonImages];
		if (!images) {
			return null;
		}

		return {
			streamyardView: images.streamyardView,
			competitorView: images.competitorView,
			competitor: competitor as CompetitorType,
			competitorName,
		};
	};

	switch (imageType) {
		case 'overflow-comparison': {
			const assets = getAssets();
			if (!assets) return null;
			return <OverflowComparison className={className} {...assets} />;
		}
		// Other templates might have different image types in the future
		default:
			return null;
	}
};

export default MainImages;
